import React, { Component } from 'react';

/*PROFILE DEPENDENCIES */

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import CssBaseline from '@material-ui/core/CssBaseline';
import { connect } from 'react-redux';
import withStyles from '@material-ui/core/styles/withStyles';
import CircularProgress from '@material-ui/core/CircularProgress';
import ChangePasswordModal from "./ChangePasswordModal";
import UploadAvatar from "./UploadAvatar"



//estilo
const styles = theme => ({
  appBar: {
    position: 'relative',
  },
  layout: {
    width: 'auto',
    //marginLeft: theme.spacing.unit * 2,
    //marginRight: theme.spacing.unit * 2,
    [theme.breakpoints.up(600 + theme.spacing.unit * 2 * 2)]: {
      width: 600,
      marginLeft: 'auto',
      marginRight: 'auto',
    }, 
  },
  paper: {
    //marginTop: theme.spacing.unit * 3,
    //marginBottom: theme.spacing.unit * 3,
    //padding: theme.spacing.unit * 2,
    [theme.breakpoints.up(200 + theme.spacing.unit * 1 * 2)]: {
      marginTop: theme.spacing.unit * 6,
      marginBottom: theme.spacing.unit * 6,
      padding: theme.spacing.unit * 3,
    },
    
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit,
  },
  contenedor:{
  }
});

 class ProfileView extends Component {
  static propTypes = {

  };
  constructor(props) {
    super(props)
  
    this.state = {
       names:"", 
       surnames:"",
       email:"",
       user:"",
       username:"",
       person:"",
       changingPassword:false,
       edition:false, 
       formValid:true,
       showSuccess:false,
       errores:{
         names:false,
         surnames:false, 
         username: false
       }, 
       openDialog:false,
       availabilityMessage:""
    }
    this.handleChange=this.handleChange.bind(this)
    this.updateProfileInfo=this.updateProfileInfo.bind(this)
    this.openChangePasswordDialog=this.openChangePasswordDialog.bind(this)
    this.closeChangePasswordDialog= this.closeChangePasswordDialog.bind(this)
    this.profileContainer=React.createRef();
  }

  UNSAFE_componentWillMount(){

    this.props.setLoading()
    this.props.getProfile()
    this.setState({
      availabilityMessage:""
    })
  }
  UNSAFE_componentWillReceiveProps(nextProps)
  {
     
    if(nextProps.profileInfo!==null){
      this.setState({
        names:nextProps.profileInfo.names, 
        surnames:nextProps.profileInfo.surnames, 
        email:nextProps.profileInfo.email, 
        username:nextProps.profileInfo.username, 
        user:nextProps.profileInfo.user, 
        person:nextProps.profileInfo.person
      })
    }
    this.setState({
      availabilityMessage:nextProps.checkingMessage
    })
    if( nextProps.updatingSuccess===true){
      this.setState({showSuccess:nextProps.updatingSuccess})
      setTimeout(() => {
        this.setState({
          showSuccess:false
        })
      }, 5000);
    }
  }
  handleChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.id? target.id:target.name;
    if(name==="names"){
      this.setState({
        names:value
      })
      this.validateForm(1, value);
    }else if(name==="surnames"){
      this.setState({
        surnames:value
      })
      this.validateForm(2, value);
    }else if (name==="username"){
      this.setState({
        username:value,
        availabilityMessage:""
      })
      this.validateForm(3, value);
    }
  }
  validateForm=(tipo, valor)=>{
    let errores= this.state.errores
    if(tipo===1){
      if(valor.trim()===""){
        errores.names=true
      }else{
        errores.names=false
      }
      this.setState({
        errores:errores
      })
    }else if(tipo===2){
      if(valor.trim()===""){
        errores.surnames=true
      }else{
        errores.surnames=false
      }
      this.setState({
        errores:errores
      })
    }else if(tipo===3){
      if(valor.trim()===""){
        errores.username=true
      }else{
        errores.username= false
      }
    }
  }

  updateProfileInfo=()=>{
    this.setState({availabilityMessage:""})
    if(!this.state.errores.surnames && !this.state.errores.names){
      this.props.setLoading()
      this.props.updatePersonInfo({
        names:this.state.names,
        surnames:this.state.surnames, 
        username:this.state.username,
        person: this.state.person,
        usernameHasChanged:localStorage.getItem("username")!==this.state.username
      })
    }
  }
  openChangePasswordDialog=()=>{
    this.props.unsetLoadingPassword();
    this.setState({
      openDialog:true
    })
  }
  closeChangePasswordDialog=()=>{
    this.setState({
      openDialog:false
    })
  }
  componentDidMount()
  {
    const script = document.createElement("script");
    script.async = true;
    script.type = 'text/javascript';
    script.src = "https://pems.outseta.com/Scripts/client/dist/outseta.profile.widget.min.js";
    this.profileContainer.appendChild(script);   
    /*global Outseta*/
    setTimeout(() => {
          let token_outseta = localStorage.getItem("token_outseta");
          if(typeof Outseta !== 'undefined')
          {
            Outseta.setAccessToken(token_outseta);
          }
      }, 1000);
    
    
  }
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.contenedor} ref={el => (this.profileContainer = el)} >
        <CssBaseline />
        <main className={classes.layout}>
          <ChangePasswordModal 
            openDialog={this.state.openDialog} 
            closeDialog={this.closeChangePasswordDialog}
            updatePassword={this.props.updatePassword}
            setLoadingPassword={this.props.setLoadingPassword}
            loadingChangePassword={this.props.loadingChangePassword}
            changePasswordStatus={this.props.changePasswordStatus}
          />
          {
            this.props.loadingPerson? 

            <Paper className={classes.paper}>
              <Typography align="center">
                Loading
              </Typography>
              <div style={{textAlign:"center"}}>
                  <CircularProgress number={100}/>
              </div>
            </Paper>
            :
            
            <UploadAvatar
              uploadAvatar={this.props.uploadAvatar}
             />
        
          }
          </main>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
  };
}


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(ProfileView));


// WEBPACK FOOTER //
// ./src/features/profile/ProfileView.js